import MultiplierForm from './MultiplierForm.component';

export default MultiplierForm;
